<template>
  <div class="common-upload">
    <Upload ref="upload" type="drag" :headers="headers" :with-credentials=true :data="data" :show-upload-list=false
            :multiple="false"
            :default-file-list="defaultFileList"
            :on-success="handleSuccess"
            :before-upload="beforeUpload"
            :onProgress="onProgress"
            :showUploadList="false"
            :accept="accept" :action="action">
      <div style="padding: 10px 0">
        <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
        <p>{{text}}</p>
      </div>
    </Upload>
    <ul>
      <li v-for="(item, index) in fileList">
        <template v-if="item && ((!item.status) || (item.status && item.status === 'finished'))">
          <a :href="item.url" target="_blank" >{{item.name}}</a> &nbsp;&nbsp;<a href="javascript:void(0)" v-on:click="handleRemove(item)" style="color: red">删除</a>
        </template>
        <template v-else>
          <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
        </template>
      </li>
    </ul>
  </div>
</template>
<script>
  export default {
    name: 'FileUpload',
    props: {
      defaultFileList: {
        type: [Array, Object],
        default () {
          return []
        }
      },
      params: {
        type: [Array, Object],
        default () {
          return {bucket: 'ting'}
        }
      },
      num: {
        type: [Number],
        default () {
          return 1
        }
      },
      accept: {
        type: String,
        default () {
          return '*'
        }
      },
      text: {
        type: String,
        default () {
          return '点击或将文件拖拽到这里上传'
        }
      }
    },
    data () {
      return {
        action: '',
        data: this.params,
        headers: {},
        visible: false,
        fileList: [],
        fileIndex: 1
      }
    },
    methods: {
      handleRemove (file) {
        const fileList = this.fileList
        this.fileList.splice(fileList.map(item => item.uid).indexOf(file.uid), 1)
        this.emitInput(this.fileList)
      },
      onRemove (file, fileList) {
        this.emitInput(fileList)
      },
      handleSuccess (res, file, fileList) {
        if (this.fileList.length > this.num) {
          return
        }

        this.$Message.destroy()
        this.$Message.info('上传成功')

        file.url = res.data.url
        file.name = res.data.name
        file.fileId = res.data.fileId
        file.size = res.data.size

        this.fileList.push(file)

        this.emitInput(this.fileList)
      },
      beforeUpload () {
        this.headers.token = this.$store.get('token')
        if (this.$store.get('account') && this.$store.get('password')) {
          this.headers.account = this.$store.get('account')
          this.headers.password = this.$store.get('password')
        }

        if (this.fileList.length >= this.num) {
          this.$Message.warning('上传文件不能超过 ' + this.num + ' 个')
          return false
        }
        this.$Message.loading('服务器正在处理中...', 0)
        return true
      },
      onProgress (event, file) {
      },
      emitInput (fileList) {
        let v = fileList.map(item => {
          return {name: item.name, url: item.url, fileId: item.fileId, size: item.size}
        })
        this.$emit('on-file-change', v)
        this.$emit('input', v.map(item => item.name).join(','))
      }
    },
    watch: {
      defaultFileList: function (fileList) {
        this.fileList = fileList.map(item => {
          item.status = 'finished'
          item.percentage = 100
          item.uid = Date.now() + this.fileIndex++
          return item
        })
      }
    },
    created: function () {
      this.action = this.$appConfig.baseUrl + '/upload/fileUpload'
      this.fileList = this.defaultFileList
    },
    mounted () {
    }
  }
</script>
<style scoped lang="less">
  .common-upload {

    .upload-list {
      margin: 5px 0;
      display: inline-block;
      width: 60px;
      height: 60px;
      text-align: center;
      line-height: 60px;
      border: 1px solid transparent;
      border-radius: 4px;
      overflow: hidden;
      background: #fff;
      position: relative;
      box-shadow: 0 1px 1px rgba(0, 0, 0, .2);

      a {
        width: 100%;
        height: 100%;
      }
    }
    .upload-list-cover {
      display: none;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, .4);
    }
    .upload-list:hover .upload-list-cover {
      display: block;
    }
    .upload-list-cover i {
      color: #fff;
      font-size: 20px;
      cursor: pointer;
      margin: 0 2px;
    }

  }
</style>



// WEBPACK FOOTER //
// FileUpload.vue?e7f9c2a2